import {
    AddStickerRequest,
    AddStickerResponse,
    DeleteStickerRequest,
    DeleteStickerResponse,
    GetAllStickersResponse,
    Sticker,
    StickerShared
} from "../../models/sticker"
import { queryApi } from "../api"
import { handleQueryApiError } from "../utility/error"

const TRANSLATION_NAMESPACE = "error:stickers."
const CREATE_STICKER_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}create-sticker-failed`
const UPDATE_STICKER_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}update-sticker-failed`
const DELETE_STICKER_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}delete-sticker-failed`

export const stickersApiController = queryApi.injectEndpoints({
    endpoints: build => {
        return {
            getStickers: build.query<GetAllStickersResponse<Sticker>, string>({
                query: projectId => ({
                    url: "stickers/get-all-stickers",
                    method: "POST",
                    body: {
                        CustomerId: projectId
                    },
                    baseUrl: "/api"
                })
            }),
            getSharedStickers: build.query<GetAllStickersResponse<StickerShared>, string>({
                query: projectId => ({
                    url: "stickers/share/get-all-stickers",
                    method: "GET",
                    params: {
                        customerId: projectId
                    }
                })
            }),
            createSticker: build.mutation<AddStickerResponse, AddStickerRequest>({
                query: body => ({
                    url: "stickers",
                    method: "PUT",
                    body: body,
                    baseUrl: "/api"
                }),
                async onQueryStarted(params, { dispatch, queryFulfilled }) {
                    try {
                        const res = await queryFulfilled
                        const projectId = params.Sticker.CustomerId
                        if (res.data.Success) {
                            dispatch(
                                stickersApiController.util.updateQueryData("getStickers", projectId, draft => {
                                    draft.Stickers.push(params.Sticker)
                                })
                            )
                        }
                    } catch (e) {
                        handleQueryApiError(dispatch, CREATE_STICKER_FAILED_MESSAGE, e)
                    }
                }
            }),
            updateSticker: build.mutation<AddStickerResponse, AddStickerRequest>({
                query: body => ({
                    url: "stickers",
                    method: "POST",
                    body: body,
                    baseUrl: "/api"
                }),
                async onQueryStarted(params, { dispatch, queryFulfilled }) {
                    try {
                        const res = await queryFulfilled
                        const projectId = params.Sticker.CustomerId
                        if (res.data.Success) {
                            dispatch(
                                stickersApiController.util.updateQueryData("getStickers", projectId, draft => {
                                    const id = params.Sticker.Id
                                    const index = draft.Stickers.findIndex(sticker => sticker.Id === id)
                                    if (index !== -1) {
                                        draft.Stickers.splice(index, 1, params.Sticker)
                                    }
                                })
                            )
                        }
                    } catch (e) {
                        handleQueryApiError(dispatch, UPDATE_STICKER_FAILED_MESSAGE, e)
                    }
                }
            }),
            deleteSticker: build.mutation<DeleteStickerResponse, DeleteStickerRequest>({
                query: body => ({
                    url: "stickers",
                    method: "DELETE",
                    body: body,
                    baseUrl: "/api"
                }),
                async onQueryStarted(params, { dispatch, queryFulfilled }) {
                    try {
                        const res = await queryFulfilled
                        const projectId = params.CustomerId
                        if (res.data.Success) {
                            dispatch(
                                stickersApiController.util.updateQueryData("getStickers", projectId, draft => {
                                    const id = params.StickerId
                                    const index = draft.Stickers.findIndex(sticker => sticker.Id === id)
                                    if (index !== -1) {
                                        draft.Stickers.splice(index, 1)
                                    }
                                })
                            )
                        }
                    } catch (e) {
                        handleQueryApiError(dispatch, DELETE_STICKER_FAILED_MESSAGE, e)
                    }
                }
            })
        }
    }
})

export const {
    useLazyGetStickersQuery,
    useGetStickersQuery,
    useGetSharedStickersQuery,
    useCreateStickerMutation,
    useUpdateStickerMutation,
    useDeleteStickerMutation
} = stickersApiController
